import { render, staticRenderFns } from "./questionAsk.vue?vue&type=template&id=a36399f4&scoped=true"
import script from "./questionAsk.vue?vue&type=script&lang=js"
export * from "./questionAsk.vue?vue&type=script&lang=js"
import style0 from "./questionAsk.vue?vue&type=style&index=0&id=a36399f4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36399f4",
  null
  
)

export default component.exports